import { FEEDBACK_CONSENT, type FeedbackKind } from '@shh/shared';
import { locale } from '../lib/locale';

/**
 * Texts of "Ideen & Feedback". German is the master; English (1.19) has the same keys. The
 * consent texts come from @shh/shared, because the server stores which text somebody agreed to.
 */
export const FEEDBACK_TEXT = {
  de: {
    title: 'Ideen & Feedback',
    entry: 'Ideen & Feedback',
    intro:
      'Was klappt gut, was nervt, was fehlt euch? Wir lesen jede Nachricht – eure Wünsche bestimmen mit, was als Nächstes kommt.',
    ratingLabel: 'Wie zufrieden seid ihr mit Larovi Home?',
    ratingHint: 'Freiwillig – 1 = gar nicht, 5 = sehr',
    kindLabel: 'Worum geht es?',
    kinds: {
      bug: { label: 'Fehler', hint: 'Etwas funktioniert nicht' },
      improvement: { label: 'Verbesserung', hint: 'Bestehendes besser machen' },
      feature: { label: 'Neue Funktion', hint: 'Etwas, das noch fehlt' },
    } satisfies Record<FeedbackKind, { label: string; hint: string }>,
    messageLabel: 'Deine Nachricht',
    placeholders: {
      bug: 'Was ist passiert? Was hast du erwartet?',
      improvement: 'Was könnten wir besser machen?',
      feature: 'Was fehlt dir – und wofür würdest du es nutzen?',
    } satisfies Record<FeedbackKind, string>,
    empty: 'Bitte schreib kurz, worum es geht – oder wähle eine Zahl.',
    consent: FEEDBACK_CONSENT.de,
    meta: 'Automatisch dabei: die Ansicht, von der du kommst, die App-Version und der Gerätetyp.',
    send: 'Feedback senden',
    sending: 'Wird gesendet …',
    sendHint: 'Geht direkt an uns, das Team von Larovi Home.',
    thanks: 'Danke! Deine Nachricht ist bei uns angekommen.',
    thanksContact: 'Wenn wir Fragen haben, melden wir uns per E-Mail.',
    another: 'Noch etwas schreiben',
    back: 'Zurück',
    locked: 'Feedback können Eltern und Teens mit eigenem Konto schicken.',
  },
  en: {
    title: 'Ideas & feedback',
    entry: 'Ideas & feedback',
    intro:
      'What works well, what bugs you, what’s missing? We read every message – your wishes help decide what comes next.',
    ratingLabel: 'How happy are you with Larovi Home?',
    ratingHint: 'Optional – 1 = not at all, 5 = very',
    kindLabel: 'What is it about?',
    kinds: {
      bug: { label: 'Bug', hint: 'Something isn’t working' },
      improvement: { label: 'Improvement', hint: 'Make something better' },
      feature: { label: 'New feature', hint: 'Something that’s missing' },
    } satisfies Record<FeedbackKind, { label: string; hint: string }>,
    messageLabel: 'Your message',
    placeholders: {
      bug: 'What happened? What did you expect?',
      improvement: 'What could we do better?',
      feature: 'What’s missing – and what would you use it for?',
    } satisfies Record<FeedbackKind, string>,
    empty: 'Please write a few words about it – or pick a number.',
    consent: FEEDBACK_CONSENT.en,
    meta: 'Included automatically: the screen you came from, the app version and the type of device.',
    send: 'Send feedback',
    sending: 'Sending …',
    sendHint: 'Goes straight to us, the Larovi Home team.',
    thanks: 'Thank you! Your message has reached us.',
    thanksContact: 'If we have any questions, we’ll get back to you by email.',
    another: 'Write something else',
    back: 'Back',
    locked: 'Parents and teens with their own account can send feedback.',
  },
} as const;

export const feedbackText = FEEDBACK_TEXT[locale];
